import React from 'react';

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="dashboard-error" role="alert" aria-live="assertive">
          <div className="dashboard-error__icon">⚠</div>
          <h2 className="dashboard-error__title">Something went wrong</h2>
          <p className="dashboard-error__message">
            {this.state.error?.message || 'An unexpected error occurred while loading the dashboard.'}
          </p>
          <button
            onClick={() => {
              this.setState({ hasError: false, error: null });
              window.location.reload();
            }}
            className="dashboard-error__button"
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
